module.exports = __webpack_public_path__ + "img/BannerColaboradoresyPymeDesktop.671fa73f.png";